module.exports = __webpack_public_path__ + "media/yolo-3.0/Books-0dd39ade.svg";